<div ngbAccordion #OuterAccordion="ngbAccordion" class="custom-collapse px-1">
  @for (group of groups; track trackByDate($index, group)) {
    <div ngbAccordionItem>
      <h2 ngbAccordionHeader>
        <button ngbAccordionButton>
          <span class="lead collapse-title group-header-container f-gap-small">
            <div
              class="custom-control custom-checkbox not-fixed-width"
              (click)="$event.stopPropagation()"
            >
              <input
                type="checkbox"
                class="custom-control-input"
                [id]="
                  componentId + '-grp-orig-' + group.type + '-' + group.date
                "
                [checked]="areAllGroupItemsSelected(group.itemIndexes)"
                (change)="onToggleGroupSelectAll(group.itemIndexes, $event)"
              />
              <label
                class="custom-control-label"
                [for]="
                  componentId + '-grp-orig-' + group.type + '-' + group.date
                "
              ></label>
            </div>
            <div class="truncate flex-grow-1">
              <div class="bold-text">{{ "MENU.BY_DATE" | translate }}</div>
              <div class="margin-top-small">
                {{ group.date | date: "d MMM y" }}
              </div>
            </div>
            <div class="truncate flex-grow-1">
              <div class="bold-text">
                {{ "CUSTOM_SHIP_DATES.QTY" | translate }}
              </div>
              <div class="margin-top-small">{{ group.totalQty }}</div>
            </div>
            <div class="truncate flex-grow-1">
              <div class="bold-text">
                {{ "CUSTOM_SHIP_DATES.ORIGINAL_DATE" | translate }}
              </div>
              <div class="margin-top-small">
                {{ group.maxRequestedDeliveryDate | date: "d MMM y" }}
              </div>
            </div>
            <div class="truncate flex-grow-1">
              <div class="bold-text">
                {{ "CUSTOM_SHIP_DATES.N_ORDER_ITEMS" | translate }}
              </div>
              <div class="margin-top-small">{{ group.itemIndexes.length }}</div>
            </div>
          </span>
        </button>
      </h2>
      <div ngbAccordionCollapse>
        <div ngbAccordionBody>
          <ng-template>
            <app-items-table
              [itemIndexes]="group.itemIndexes"
              [orderItemsFormCustomDate]="orderItemsFormCustomDate"
              [supportsSplitDelivery]="supportsSplitDelivery"
              [showStockQty]="showStockQty"
              [maxStoreCustomDate]="maxStoreCustomDate"
              [componentId]="componentId"
              [idPrefix]="'-orig-'"
              [filterCustomDate]="group.type === 'custom' ? group.date : null"
              (dateAdded)="dateAdded.emit($event)"
              (stockDateAdded)="stockDateAdded.emit($event)"
              (customDateCleared)="customDateCleared.emit($event)"
              (dateRemoved)="dateRemoved.emit($event)"
              (dateTimeChanged)="dateTimeChanged.emit($event)"
            >
            </app-items-table>
          </ng-template>
        </div>
      </div>
    </div>
  }
</div>
